module.exports = __webpack_public_path__ + "images/9f0da659034bf5dd5a5f49e36e50b86f.svg";